"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("../utils/base");
var spacing_1 = require("./spacing");
var colors_1 = require("./colors");
var fontWeight_1 = require("./fontWeight");
var palette_1 = require("./palette");
exports.defaultSpacing = [spacing_1.spacing.md, spacing_1.spacing.xs];
var marketingSpacing = [spacing_1.spacing.lg, spacing_1.spacing.sm];
var paddingWithBorderInside = function (borderWidth, initialPadding) {
    if (initialPadding === void 0) { initialPadding = exports.defaultSpacing; }
    // initial pad minus the border width + a single pixel for the standard border width expected by other components
    return base_1.convertPixelsToRem(initialPadding[1].getPxValue() - borderWidth + 1) + " " + base_1.convertPixelsToRem(initialPadding[0].getPxValue() - borderWidth + 1);
};
exports.borderColor = palette_1.palette.border.dark;
var marketingColor = palette_1.palette.secondary.main;
var whiteColor = palette_1.palette.text.contrast;
var blackColor = palette_1.palette.text.primary;
exports.button = {
    default: {
        background: colors_1.color.transparent,
        border: "1px solid " + exports.borderColor,
        color: blackColor,
        contrastColor: whiteColor,
        fontWeight: fontWeight_1.fontWeight.bold,
        padding: paddingWithBorderInside(1),
        textTransform: 'auto',
        hover: {
            background: colors_1.color.transparent,
            border: "2px solid " + exports.borderColor,
            padding: paddingWithBorderInside(2)
        },
        focus: {
            background: colors_1.color.transparent,
            border: "3px solid " + exports.borderColor,
            padding: paddingWithBorderInside(3)
        },
        disabled: {
            background: colors_1.color.transparent,
            border: "1px solid " + exports.borderColor,
            color: blackColor,
            contrastColor: whiteColor,
            opacity: 0.5,
            padding: paddingWithBorderInside(1)
        }
    },
    primary: {
        background: palette_1.palette.primary.main,
        border: "2px solid transparent",
        color: whiteColor,
        padding: paddingWithBorderInside(2),
        hover: {
            border: "2px solid transparent",
            background: palette_1.palette.primary.dark
        },
        focus: {
            border: "2px solid " + palette_1.palette.primary.veryDark,
            padding: paddingWithBorderInside(2),
            color: whiteColor
        },
        disabled: {
            opacity: 0.5,
            background: palette_1.palette.primary.veryDark,
            border: "2px solid transparent",
            padding: paddingWithBorderInside(2),
            color: whiteColor
        }
    },
    link: {
        background: colors_1.color.transparent,
        border: "2px solid transparent",
        color: palette_1.palette.primary.dark,
        contrastColor: whiteColor,
        padding: paddingWithBorderInside(2),
        hover: {
            background: colors_1.color.B2,
            contrastBackground: palette_1.palette.primary.dark,
            border: "2px solid transparent",
            padding: paddingWithBorderInside(2)
        },
        focus: {
            border: "2px solid " + palette_1.palette.primary.light,
            padding: paddingWithBorderInside(2)
        },
        disabled: {
            border: "2px solid transparent",
            color: palette_1.palette.primary.light,
            contrastColor: whiteColor,
            opacity: 0.5,
            padding: paddingWithBorderInside(2)
        }
    },
    marketing: {
        border: "2px solid " + marketingColor,
        contrastBorder: "2px solid " + whiteColor,
        color: marketingColor,
        contrastColor: whiteColor,
        fontWeight: fontWeight_1.fontWeight.bold,
        padding: paddingWithBorderInside(2, marketingSpacing),
        textTransform: 'uppercase',
        hover: {
            background: marketingColor,
            contrastBackground: whiteColor,
            border: "2px solid " + marketingColor,
            contrastBorder: "2px solid " + whiteColor,
            color: whiteColor,
            contrastColor: colors_1.color.B6,
            padding: paddingWithBorderInside(2, marketingSpacing)
        },
        focus: {
            background: colors_1.color.transparent,
            border: "2px solid " + palette_1.palette.secondary.dark,
            contrastBorder: "2px solid " + colors_1.color.B3,
            padding: paddingWithBorderInside(2, marketingSpacing)
        },
        disabled: {
            background: colors_1.color.transparent,
            border: "2px solid " + marketingColor,
            contrastBorder: "2px solid " + whiteColor,
            color: marketingColor,
            contrastColor: whiteColor,
            opacity: 0.5,
            padding: paddingWithBorderInside(2, marketingSpacing)
        }
    }
};
/**
 * This is the best we can do without typeguards (which drop in TS 3.7)
 * to verify that the `button` implements the `Button` interface.
 *
 * TODO: Use TypeGuards instead.
 */
function isButtonStyle(_) { }
isButtonStyle(exports.button);
//# sourceMappingURL=button.js.map